import cx from 'clsx';
import React from 'react';

import { ReactComponent as TableSort } from '@assets/svg/table-sort.svg';

import { initialSorting } from '@constants/tableSorting';

import useTranslation from '@hooks/useTranslation';

import { selectAISort, useActionItemsStoreAction } from '@pages/ActionItems/store/useActionItemsStore';

import { selectAppPersistOnBoardStart } from '@store/useAppStorePersist';

import style from './style.module.scss';

interface IProps {
  hasWorkOrder: boolean;
  sortTooltipId?: string;
}

const ActionItemsTableHead: React.FC<IProps> = ({ hasWorkOrder, sortTooltipId }) => {
  const { t } = useTranslation();

  const { setAISort } = useActionItemsStoreAction();
  const onBoard = selectAppPersistOnBoardStart();
  const sorting = selectAISort();

  const handleClick = (key: string) => {
    if (!sorting.id || sorting.id !== key) {
      setAISort({ id: key, desc: false });
      return;
    }
    const { id, desc } = sorting;
    if (desc) {
      setAISort(initialSorting);
    } else {
      setAISort({ id, desc: true });
    }
  };

  return (
    <div className={cx(style.tableHead, { [style.tableHeadFixed]: onBoard })}>
      <div
        className={cx(style.tableHeadLocation, {
          [style.tableHeadLocationWithoutWo]: !hasWorkOrder,
        })}
        onClick={() => handleClick('location_name')}
      >
        {t('Location')}
        <TableSort
          data-tooltip-content="location_name"
          data-tooltip-id={sortTooltipId}
          className={cx(style.tableSortIcon, { [style.activeSort]: sorting.id === 'location_name' })}
        />
      </div>
      <div
        className={cx(style.tableHeadEquipment, {
          [style.tableHeadEquipmentWithoutWo]: !hasWorkOrder,
        })}
        onClick={() => handleClick('equipment_name')}
      >
        <span className={style.bigWidthShow}>{t('Equipment')}</span>
        <span className={style.smallWidthShow}>{t('Equipment/Component')}</span>
        <TableSort
          data-tooltip-content="equipment_name"
          data-tooltip-id={sortTooltipId}
          className={cx(style.tableSortIcon, { [style.activeSort]: sorting.id === 'equipment_name' })}
        />
      </div>
      <div
        className={cx(style.tableHeadComponent, {
          [style.tableHeadComponentWithoutWo]: !hasWorkOrder,
        })}
        onClick={() => handleClick('component_name')}
      >
        {t('Component')}
        <TableSort
          data-tooltip-content="component_name"
          data-tooltip-id={sortTooltipId}
          className={cx(style.tableSortIcon, { [style.activeSort]: sorting.id === 'component_name' })}
        />
      </div>
      <div
        className={cx(style.tableHeadType, {
          [style.tableHeadTypeWithoutWo]: !hasWorkOrder,
        })}
        onClick={() => handleClick('type')}
      >
        <span className={style.bigWidthShow}>{t('Type')}</span>
        <span className={style.smallWidthShow}>{t('Type/Work Order')}</span>
        <TableSort
          data-tooltip-content="type"
          data-tooltip-id={sortTooltipId}
          className={cx(style.tableSortIcon, { [style.activeSort]: sorting.id === 'type' })}
        />
      </div>
      {hasWorkOrder && (
        <div className={style.tableHeadwWo} onClick={() => handleClick('wo_number')}>
          {t('Work Order')}
          <TableSort
            data-tooltip-content="wo_number"
            data-tooltip-id={sortTooltipId}
            className={cx(style.tableSortIcon, { [style.activeSort]: sorting.id === 'wo_number' })}
          />
        </div>
      )}

      <div className={style.tableHeadTime} onClick={() => handleClick('life_time_value')}>
        {t('Lifetime')}
        <TableSort
          data-tooltip-content="life_time_value"
          data-tooltip-id={sortTooltipId}
          className={cx(style.tableSortIcon, { [style.activeSort]: sorting.id === 'life_time_value' })}
        />
      </div>
      <div className={style.tableHeadStatus} onClick={() => handleClick('updated_at')}>
        {t('Last update')}
        <TableSort
          data-tooltip-content="updated_at"
          data-tooltip-id={sortTooltipId}
          className={cx(style.tableSortIcon, { [style.activeSort]: sorting.id === 'updated_at' })}
        />
      </div>
    </div>
  );
};

export default ActionItemsTableHead;
